import React from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import { makeStyles, tokens } from "@fluentui/react-components";
import { useAuth } from "react-oidc-context";
import Profile from "./Profile";
import TabMenu from "./TabMenu";
import Investment from "./Investment";
import SelectionSet from "./SelectionSet";
import SheetOption from "./SheetOption";
import ErrorHandling from "./ErrorHandling";
import Home from "./Home";
import HomeOnline from "./HomeOnline";

const useStyles = makeStyles({
  root: {
    height: "100vh",
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: tokens.lineHeightBase300,
  },
});

const Dashboard = () => {
  const auth = useAuth();
  const styles = useStyles();

  return (
    <div className={styles.root}>
      {auth.isAuthenticated && (
        <HashRouter>
          <Routes>
            <Route path="/" element={<Profile />} />
            <Route path="/home" element={<Home />} />
            <Route path="/homeonline" element={<HomeOnline />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/tabmenu" element={<TabMenu />} />
            <Route path="/investment" element={<Investment />} />
            <Route path="/SelectionSet" element={<SelectionSet />} />
            <Route path="/sheetoption" element={<SheetOption />} />
            <Route path="/errorhandling" element={<ErrorHandling />} />
          </Routes>
        </HashRouter>
      )}
    </div>
  );
};

export default Dashboard;
